
import { Headline } from '@headlines/types/headline';
import BaseButton from '@core/components/UI/BaseButton.vue';
import { HeadlineTitle, HeadlineImage, HeadlineIcons } from '../../fragments';
import BaseBlock from '@headlines/utils/BaseBlock';
import BlockTypeSettings from '@headlines/types/block/21-30/blockType22';
import chunkArray from '@headlines/utils/ChunkArray';

const defaultSettings = {
  icons: true,
  category: true,
};

interface Computed {
  chunkedItems: Headline[][];
}

export default BaseBlock<BlockTypeSettings>(defaultSettings).extend<unknown, unknown, Computed, unknown>({
  components: {
    HeadlineImage,
    HeadlineTitle,
    HeadlineIcons,
    BaseButton,
  },
  computed: {
    chunkedItems() {
      return chunkArray(this.data.items, 3);
    },
  },
});
